import React from 'react';

const MenuCollage = ({ menu }) => {
    let images = [];
    menu._embedded['varma:days'].data.forEach(d => {
        if (images.length === 4) {
            return;
        }

        d.meals.forEach(m => {
            images.push(m.recipe.image);
        });
    });

    if (images.length === 0) {
        images.push('https://cdn.varmasverige.se/assets/placeholder.png');
    }
    let columnCount = 2;
    let height = '102px';
    if (images.length < 4) {
        columnCount = 1
        images = [images[0]];
        height = '205px';
    }

    return (
        <div style={{ lineHeight: '0', columnCount: columnCount, columnGap: '0px'}}>
            {images.map((i, index) => (
                 <img style={{ width: '100%', display: 'inherit', height: height, objectFit: 'cover'}} src={i} alt={`thumbnail ${index}`} key={index} />
            ))}
        </div>
    );
}

export default MenuCollage;


// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/MenuCollage.js